export default {
  init() {
    var $header;

    // JavaScript to be fired on the home page
    $(document).ready(function(){
      $(document).scroll();
    });

    $(document).scroll(function() {
        var y = $(document).scrollTop();
        $('body').addClass('scroll--at-top', y == 0);

        if($header == null) {
          $header = $('header.header');
        }
        $header.toggleClass('header--transparent', y == 0);
    });

    $(document).ready(function () {
        $(".masthead__button").magnificPopup({
            type: "iframe",
        });
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js